<div class="flex flex-col overflow-hidden items-stretch justify-start w-full h-full p-2">
  @if (documents().length === 0) {
    <div class="flex flex-col items-center justify-center w-full h-full gap-2">
      @if (isUploadingDocuments()) {
        <div class="flex flex-row items-center justify-center gap-2">
          <p class="text-yellow-400 animate-pulse-slow text-xs">Uploading document...</p>
        </div>
      } @else {
        <p class="text-neutral-400">No documents available</p>
        <div
          (click)="uploadDocument()"
          class="py-2 px-3 h-8 font-normal items-center flex text-center bg-neutral-600 rounded-lg text-xs gap-2 hover:bg-neutral-400 cursor-pointer text-white"
          tabindex="0"
          pTooltip="Upload Document"
          tooltipPosition="bottom"
        >
          <i class="ph ph-sparkle text-base text-yellow-500"></i>
          Upload New Document
        </div>
      }
    </div>
  } @else {
    <div
      class="flex flex-col w-full scrollbar-dark gap-2 items-center rounded-lg text-xs overflow-y-auto"
    >
      @for (doc of documents(); track doc) {
        <div
          class="flex flex-col w-full gap-2 items-center rounded-lg px-3 py-4 text-xs shadow-md select-none bg-neutral-900"
        >
          <div class="flex flex-row w-full gap-2 items-center justify-between">
            <div class="flex flex-row gap-2 items-center">
              <i class="ph ph-file-pdf text-base text-neutral-200"></i>
              <p class="text-white font-bold text-sm">{{ doc.name }}</p>
            </div>
            <div
              (click)="toggleDescription(doc)"
              class="self-center font-semibold items-center flex text-center cursor-pointer text-xs text-yellow-500"
              tabindex="0"
              pTooltip="Show/Hide Description"
              tooltipPosition="bottom"
            >
              {{ describeDocument?.id === doc.id ? 'Hide' : 'Show' }}
            </div>
          </div>
          <div
            class="flex flex-col w-full gap-1 pl-6 items-start justify-between font-normal text-xs"
          >
            <div class="flex flex-row w-full gap-2 items-center justify-between">
              <div class="flex flex-row gap-2 items-center text-xs">
                <p class="text-white font-bold">
                  File Name:
                  <span class="text-neutral-200 font-normal">{{ doc.file_name }}</span>
                </p>
              </div>
            </div>
            <div class="flex flex-row w-full gap-2 items-center justify-between">
              <div class="flex flex-row gap-2 items-center text-xs">
                <p class="text-white font-bold">
                  Created At:
                  <span class="text-neutral-200 font-normal">{{
                    doc.created_at | flxLogDateFormat
                  }}</span>
                </p>
              </div>
            </div>
            <div class="flex flex-row w-full gap-2 items-center justify-between">
              <div class="flex flex-row gap-2 items-center text-xs">
                <p class="text-white font-bold">
                  Document Type:
                  <span
                    class="text-neutral-200 font-normal rounded-md py-0.5 px-1  {{
                      getDocumentTypeColor(doc.documentType)
                    }}"
                    >{{ getDocumentType(doc.documentType) }}</span
                  >
                </p>
              </div>
            </div>
          </div>
          <div
            [ngClass]="
              describeDocument?.id === doc.id
                ? 'transition duration-300 ease-in-out h-auto opacity-100'
                : 'transition duration-300 ease-out h-0 hidden opacity-0'
            "
            class="flex flex-col w-full p-2 gap-2 items-start justify-between"
          >
            <p class="text-neutral-200 text-xs">Description:</p>
            <div
              class="text-neutral-200 text-xs p-2 bg-neutral-700 select-text rounded max-h-[300px] overflow-y-auto"
            >
              <div [innerHTML]="doc.description | flxAiMarkdown | async"></div>
            </div>
          </div>
          <div class="flex flex-row align-end justify-between w-full h-full gap-2 mt-2">
            <div class="flex flex-row items-center justify-start gap-1">
              <p class="text-neutral-100 text-xs">Status:</p>
              <p
                class=" text-neutral-100 py-0.5 px-1 font-semibold rounded {{
                  getStatusColor(doc.status)
                }}"
              >
                {{ doc.status }}
              </p>
            </div>
            @if (doc.status === 'Evaluated' && doc.documentType === 'business_process_definition') {
              <div class="flex flex-row gap-2">
                <div
                  (click)="useDocument(doc)"
                  class="py-2 px-3 h-8 font-normal items-center flex text-center bg-yellow-900 rounded-lg text-xs gap-2 hover:border-yellow-400 border-2 border-yellow-900 cursor-pointer text-yellow-500"
                  tabindex="0"
                  pTooltip="Use this document"
                  tooltipPosition="bottom"
                >
                  <i class="ph ph-sparkle text-base"></i>
                  Use this document
                </div>
                <div
                  (click)="generatePlanFromDocument(doc)"
                  class="py-2 px-3 h-8 font-normal items-center flex text-center bg-green-900 rounded-lg text-xs gap-2 hover:border-green-400 border-2 border-green-900 cursor-pointer text-green-400"
                  tabindex="0"
                  pTooltip="Generate a plan from this document"
                  tooltipPosition="bottom"
                >
                  <i class="ph ph-lightning text-base"></i>
                  Generate Plan
                </div>
                @if (doc.storagePath) {
                  <div
                    (click)="openPdf(doc)"
                    class="py-2 px-3 h-8 font-normal items-center flex text-center bg-blue-900 rounded-lg text-xs gap-2 hover:border-blue-400 border-2 border-blue-900 cursor-pointer text-blue-400"
                    tabindex="0"
                    pTooltip="Open PDF in new tab"
                    tooltipPosition="bottom"
                  >
                    <i class="ph ph-file-pdf text-base"></i>
                    View PDF
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
      @if (isUploadingDocuments()) {
        <div class="flex flex-row items-center justify-center gap-2">
          <p class="text-yellow-400 animate-pulse-slow text-xs">Uploading document...</p>
        </div>
      } @else {
        <div
          (click)="uploadDocument()"
          class="py-2 px-3 h-8 my-6 font-normal items-center flex text-center bg-neutral-600 rounded-lg text-xs gap-2 hover:bg-neutral-400 cursor-pointer text-white"
          tabindex="0"
          pTooltip="Upload Document"
          tooltipPosition="bottom"
        >
          <i class="ph ph-sparkle text-base text-yellow-500"></i>
          Upload New Document
        </div>
      }
    </div>
  }

  <input
    #docUpload
    [accept]="allowedDocumentFileTypes()"
    [multiple]="isMultipleDocumentUploadAllowed()"
    (change)="onFileSelected($event)"
    class="hidden peer"
    type="file"
  />
</div>
